var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm._flagShowLoading},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center d-flex flex-column align-items-center"},[_c('LoadSpinner',{staticClass:"overlay-svg"})],1)]},proxy:true}])},[_c('div',{attrs:{"id":"app"}},[_c('div',{class:[
        'layout-d',
        {
          'layout-login': _vm.isAuthenticationPage,
          'layout-app': !_vm.isAuthenticationPage,
          desktop: _vm.desktop && !_vm.isAuthenticationPage,
          mobile: !_vm.desktop && !_vm.isAuthenticationPage
        }
      ]},[_c('div',{class:[_vm.desktop ? 'sticky-menu' : '']},[(!_vm.isAuthenticationPage)?_c('Menu',{attrs:{"desktop":_vm.desktop,"device":_vm.device}}):_vm._e()],1),_c('div',{staticClass:"page"},[_c('router-view'),(!_vm.isAuthenticationPage)?_c('Footer'):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }